import { Component, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { WidgetTemplate } from '../../models/widget/widget-template.model';
import { PageWidget } from '../../models/widget/page-widget.model';
import { WidgetContent } from '../../models/widget/widget-content.model';
import { DynamicPage } from '../../models/widget/dynamic-page.model';
import { WidgetService } from '../../services/widget/widget.service';
import { BrandService } from '../../services/brand/brand.service';
import { Brand } from '../../models/brand/brand-model';
//import { Category } from '../../models/category/category.model';
import { CategoryService } from '../../services/category/category.service';
import { DisplayCategory } from '../../models/category/DisplayCategory.model';
import { DragulaService } from 'ng2-dragula';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Sales } from '../../models/sales/sales.model';
@Component({
  selector: 'app-create-page-widget',
  templateUrl: './create-page-widget.component.html',
  styleUrls: ['./create-page-widget.component.css']
})
/** create-page-widget component*/
export class CreatePageWidgetComponent {
  public widgetTemplateList: WidgetTemplate[];
  public pageWidget = new PageWidget();
  public widgetContentList: WidgetContent[] = [];
  public widgetContent = new WidgetContent();
  public dynamicPageList: DynamicPage[];
  public pageWidgetList: PageWidget[];
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  fileToUpload: File;
  tempFileToUpload: File;
  fd = new FormData();
  categoryfd = new FormData();
  customDPage: string;
  currentWidgetTemplateID: number;
  showAllWidget: boolean;
  //#region Brand Variables
  public Brands: Brand[];
  public selectedBrands: Brand[] = [];
  selectedBrandImageLeft: string;
  selectedBrandImageRight: string;
  imagePath: string;
  imageRedirectUrlLeft: string;
  imageRedirectUrlRight: string;
  isBrandLeft: boolean;
  brandLeftData: string;
  brandRightData: string;
  isTitleDuplicate: boolean;
  isBrandEdit: boolean;
  public selectedBrandIds: any[] = [];
  brandTitle: string;
  brandTitleEdit: string;
  brandTabsList: BrandTabsList[] = [];
  brandTab = new BrandTabsList();
  // #endregion
  
  // #region Category Widget Variables

  selectedCategoryImage: string;
  categoryImageRedirectUrl: string;
  categoryImageData: string;
  categoryBrandIdsData: string;
  categoryThumbnailIds: string;
  isMax6Categories: boolean;
  cateWidgetContentTypeHImageId: number;
  cateWidgetContentTypeBrandId: number;
  cateWidgetContentTypeThmnailId: number;
  cateWidgetContentTypeMenuId: number;
  public selectedCategoryBrandIds: any[] = [];
  public selectedCategorythumbnailIds: any[] = [];
  public categoryBrandsList: Brand[] = [];
  public categoryList: DisplayCategory[] = [];
  public displayPopularCategoryList: DisplayCategory[] = [];
  public allCategoryList: DisplayCategory[] = [];
  public subCategoryList: DisplayCategory[] = [];
  public thumbnailCategoryList: DisplayCategory[] = [];

  // #region Category Menu

  // #region Popular Category
  public selectedPopualarCategoryIds: any[] = [];
  public popularCategoryList: DisplayCategory[] = [];
  //public displaySubcategoryList: DisplayCategory[] = [];
  widgetContentTypePopularCatId: number;
  isMax8Categories: boolean;
  popularCategoryThumbnailIds: string;

  widgetContentTypeVendorId: number;
  productWidgetType: string;
  productWidgetTypes: any[];
  productWidgetEnum = ProductWidgetTypes;
  productWidgetTypeId: number;
  savedProductWidgetTypes: string[] = [];
  public productWidgetContentList: WidgetContent[] = [];
  public savedPageWidgetId: number;
  // #endregion Popular Category

  public parentCategoryList: DisplayCategory[];
  public SubcategoryList: DisplayCategory[];
  public ThirdLevelcategoryList: DisplayCategory[];
  //public allCategoriesList: Category[];
  public pId: number;
  public cId: number;
  public sId: number;

  public selectedPId: number;
  public selectedCId: number;
  public selectedSId: number;

  public selectedMenuCategoryIds: number[] = [];
  public selectedParentCategoryId: number;
  public categoryMenuData: string;
  public menuParentCategoryList: DisplayCategory[] = [];
  public menuCategoryList: DisplayCategory[] = [];
  public menuSubcategoryList: DisplayCategory[] = [];
  // For cateogory 2 Just to show
  public menuParentCategoryList2: DisplayCategory[] = [];
  public menuCategoryList2: DisplayCategory[] = [];
  public menuSubcategoryList2: DisplayCategory[] = [];
  public categoryBrandsList2: Brand[] = [];
  public thumbnailCategoryList2: DisplayCategory[] = [];
  categoryImageRedirectUrl2: string;
  selectedCategoryImage2: string;
  bannerImageRedirectUrl: string;
  selectedBannerImage: string;
  selectedILoveAppBannerImage: string;
  bannerImageData: string;
  bannerfd = new FormData();
  bannerWidgetContentId: number;
  saleList: Sales[];
  saleId: number;
  // #endregion 

  // #endregion
  /** create-page-widget ctor */
  constructor(private readonly widgetService: WidgetService,
    private readonly categoryService: CategoryService,
    private modalService: BsModalService,
    private readonly brandsService: BrandService,
    private dragulaService: DragulaService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("pageWidget").subscribe(
      data => {
        if (data != null) {
          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.productWidgetTypes = this.enumSelector(this.productWidgetEnum);
            this.GetWidgetTemplates();
            this.GetDynamicPages();
            this.GetAllBrands();
            this.GetCategoryList();
            this.GetAllDisplayCategoryList();
            this.GetCategoryAndCompanySales();
            this.saleId = 0;
            this.isBrandLeft = true;
            this.customDPage = "";
            this.widgetContent.data = "";
            this.productWidgetType = "";
            this.selectedILoveAppBannerImage = "";
            this.isMax6Categories = true;
            this.isMax8Categories = true;
            this.selectedPId = 0;
            this.selectedCId = 0;
            this.selectedSId = 0;
            try {
              this.dragulaService.destroy("VAMPIRES");
            } catch (e) {
            }
            this.dragulaService.createGroup("VAMPIRES", {

            });
            this.dragulaService.dropModel("VAMPIRES").subscribe(args => {
            });

            this.pId = 0
            this.cId = 0
            this.sId = 0
          }
          else {
            this.router.navigate(["/page-widget-list"]);
          }
        }
        else {
          this.router.navigate(["/page-widget-list"]);
        }
      }
    )

  }

  // #region Get Methods
  GetWidgetTemplates() {
    this.widgetService.GetWidgetTemplates().subscribe(
      data => {
        this.widgetTemplateList = data;
        
      }
    )
  }

  GetDynamicPages() {
    this.widgetService.GetDynamicPages().subscribe(
      data => {
        this.dynamicPageList = data;
      }
    )
  }
  GetAllBrands() {
    this.brandsService.getBrand().subscribe(
      data => {
        this.Brands = data;
      }

    )
  }

  GetCategoryList() {
    this.categoryService.GetAllDisplayCategoryList().subscribe(
      data => {
        this.allCategoryList = data;
        this.subCategoryList = this.allCategoryList.filter(s => s.isParent == false);
        let pc = this.allCategoryList.filter(s => s.parentCategoryID == 0);
        for (var i = 0; i < pc.length; i++) {
          this.displayPopularCategoryList.push(pc[i]);
          let category = this.allCategoryList.filter(s => s.isParent == true && s.parentCategoryID == pc[i].categoryID);
          for (var j = 0; j < category.length; j++) {
            category[j].categoryName = pc[i].categoryName + " => " + category[j].categoryName;
            this.displayPopularCategoryList.push(category[j]);
            let subCategory = this.allCategoryList.filter(s => s.parentCategoryID == category[j].categoryID);
            for (var k = 0; k < subCategory.length; k++) {
              subCategory[k].categoryName = category[j].categoryName + " => " + subCategory[k].categoryName;
              this.displayPopularCategoryList.push(subCategory[k]);
            }
          }
        }
      }
    )
  }
  GetAllDisplayCategoryList() {
    this.categoryService.GetAllDisplayCategoryList().subscribe(
      data => {
        this.categoryList = data;
        this.parentCategoryList = this.categoryList.filter(s => s.parentCategoryID == 0);
      }
    )
  }
  GetCategoryAndCompanySales() {
    this.categoryService.GetCategoryAndCompanySales().subscribe(
      data => {
        this.saleList = data;
      }
    )
  }
  //GetAllWidgetContentsOfProducts(widgetTemplateID: number) {
  //  this.widgetService.GetAllWidgetContentsOfProducts(widgetTemplateID).subscribe(
  //    data => {
  //      this.productWidgetContentList = data;
  //    }
  //  )
  //}

  enumSelector(enumName) {
    return Object.keys(enumName)
      .map(key => ({ value: key, title: enumName[key] }));
  }
  // #endregion

  // #region Widget Template Events

  toggleClass(event: any) {

    const hasClass = event.srcElement.classList.contains('check');
    var element = document.getElementsByClassName("img-check");
    for (var i = 0; i < element.length; i++) {
      element[i].classList.remove('check');
    }
    if (hasClass) {
      event.srcElement.classList.remove('check');
      // setTimeout(this.widgetTemplateID = 0, 1000);
    } else {
      event.srcElement.classList.add('check');
    }
  }
  onCheckboxChange(widgetTemplateId: number) {
    //this.pageWidget.widgetTemplateID = widgetTemplateId;
    this.currentWidgetTemplateID = widgetTemplateId;
    //this.LaodSavedWidgets(false);
    this.WidgetContentInitialization();
    this.showAllWidget = false;
    try {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0);
    }

    //this.GetAllWidgetContentsOfProducts(widgetTemplateId);
  }

  // #endregion

  // #region Brand Modal popups
  openModal(template: TemplateRef<any>, colPosition: string) {
    this.modalRef = this.modalService.show(template, this.config);
    if (colPosition == WidgetImageContents.BrandLeft.toString()) {
      this.isBrandLeft = true;
    } else if (colPosition == WidgetImageContents.BrandRight.toString()) {
      this.isBrandLeft = false;
    }

  }
  openBrandModal(template: TemplateRef<any>) {
    this.isBrandEdit = false;
    this.brandTitle = "";
    this.selectedBrandIds = [];
    this.isTitleDuplicate = false;
    this.modalRef = this.modalService.show(template, this.config);
  }
  openEditBrandModal(tabTitle: string, template: TemplateRef<any>) {
    this.isBrandEdit = true;
    this.brandTitle = tabTitle;
    this.brandTitleEdit = tabTitle;
    this.selectedBrandIds = [];
    this.isTitleDuplicate = false;
    var brandTab = this.brandTabsList.find(s => s.tabTitle == tabTitle);
    for (var i = 0; i < brandTab.BrandsList.length; i++) {
      //var selectedbrand = this.Brands.find(s => s.brandID == this.selectedBrandIds[i].brandID);
      this.selectedBrandIds.push({ "brandID": brandTab.BrandsList[i].brandID, "brandName": brandTab.BrandsList[i].brandName });
    }
    this.modalRef = this.modalService.show(template, this.config);
  }
  decline(): void {
    this.fd = new FormData();
    this.categoryfd = new FormData();
    this.bannerfd = new FormData();
    this.tempFileToUpload = null;
    this.modalRef.hide();
  }

  // #endregion

  // #region Brand Image upload Events

  uploadBrandLeftImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append(WidgetImageContents.BrandLeft.toString(), this.fileToUpload);
    //Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.selectedBrandImageLeft = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  uploadBrandRightImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append(WidgetImageContents.BrandRight.toString(), this.fileToUpload);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.selectedBrandImageRight = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
    // #endregion

  //#region Brand multi select func.

  selectedItems = [];
  dropdownSettings = {};
  subCategoryDropdownSettings = {};
  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'brandID',
      textField: 'brandName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
    this.subCategoryDropdownSettings = {
      singleSelection: false,
      idField: 'categoryID',
      textField: 'categoryName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }

  onItemSelect(item: any) {
    

  }
  onCategorySelect(item: any) {
    
  }
  onSelectAll(items: any) {
    

  }
  // #endregion Multi select func.

  // #region Adding Brand Image with data structure

  AddBrandImage() {
    if (this.isBrandLeft) {
      this.brandLeftData = "";
      //Brand Hero img data structure => BrandColPosition|url,path
      this.brandLeftData = WidgetImageContents.BrandLeft.toString() +
        "|" +
        this.imageRedirectUrlLeft +
        "," +
        WidgetImageContents.DummyPath.toString();

    } else {
      this.brandRightData = "";
      //Brand Hero img data structure => BrandColPosition:url,path
      this.brandRightData = WidgetImageContents.BrandRight.toString() +
        "|" +
        this.imageRedirectUrlRight +
        "," +
        WidgetImageContents.DummyPath.toString();
    }

    //this.imageRedirectUrl = "";
    this.modalRef.hide();
  }
    // #endregion

  // #region Add Brands to Array List

  AddBrands() {
    // check tab title duplication
    this.isTitleDuplicate = false;
    for (var i = 0; i < this.brandTabsList.length; i++) {
      if (this.brandTabsList[i].tabTitle.toLowerCase() == this.brandTitle.toLowerCase()) {
        this.isTitleDuplicate = true;
        return;
      }
    }
    if (!this.isTitleDuplicate) {
      this.brandTab = new BrandTabsList();
      for (var i = 0; i < this.selectedBrandIds.length; i++) {
        var selectedbrand = this.Brands.find(s => s.brandID == this.selectedBrandIds[i].brandID);
        
        this.brandTab.BrandsList.push(selectedbrand);
      }
      this.brandTab.tabTitle = this.brandTitle;
      this.brandTabsList.push(this.brandTab);
      this.brandTitle = "";
      this.selectedBrandIds = [];
      this.modalRef.hide();
    }

  }
  UpdateBrands() {
    
    // check tab title duplication
    this.isTitleDuplicate = false;
    if (this.brandTitle.toLowerCase() != this.brandTitleEdit.toLowerCase()) {
      for (var i = 0; i < this.brandTabsList.length; i++) {
        if (this.brandTabsList[i].tabTitle.toLowerCase() == this.brandTitle.toLowerCase()) {
          this.isTitleDuplicate = true;
          return;
        }
      }
    }
    if (!this.isTitleDuplicate) {
      // Remove existing
      var index = this.brandTabsList.findIndex(s => s.tabTitle == this.brandTitle);
      this.brandTabsList.splice(index, 1);
      //end
      this.brandTab = new BrandTabsList();
      for (var i = 0; i < this.selectedBrandIds.length; i++) {
        var selectedbrand = this.Brands.find(s => s.brandID == this.selectedBrandIds[i].brandID);
        
        this.brandTab.BrandsList.push(selectedbrand);
      }
      this.brandTab.tabTitle = this.brandTitle;
      //this.brandTabsList.push(this.brandTab);
      // will insert item into Array at the specified index(deleting 0 items first, that is, it's just an insert).
      this.brandTabsList.splice(index, 0, this.brandTab);
      this.brandTitle = "";
      this.selectedBrandIds = [];
      this.modalRef.hide();
    }

  }
  RemoveBrand(tabTitle: string, brandId: number) {
    var ans = confirm("Are you sure to Remove Brand from : " + tabTitle);
    if (ans) {
      var brandTab = this.brandTabsList.find(s => s.tabTitle == tabTitle);
      var brandTabIndex = this.brandTabsList.findIndex(s => s.tabTitle == tabTitle);
      var index = brandTab.BrandsList.findIndex(p => p.brandID == brandId);
      this.brandTabsList[brandTabIndex].BrandsList.splice(index, 1);
    }
  }
  RemoveCategoryBrand(brandId: number) {
    var ans = confirm("Are you sure to Remove Brand");
    if (ans) {
      var index = this.categoryBrandsList.findIndex(s => s.brandID == brandId);
      this.categoryBrandsList.splice(index, 1);
    }
  }

  // #endregion

  // #region Remove brand tabs

  RemoveBrandTab(brandTitle: string) {
    var ans = confirm("Are you sure to Remove : " + brandTitle);
    if (ans) {
      var index = this.brandTabsList.findIndex(s => s.tabTitle == brandTitle);
      this.brandTabsList.splice(index, 1);
    }
  }
   // #endregion

  // #region Category Widget

  OpenCategoryModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, this.config);
    this.selectedMenuCategoryIds=[];
  }
  uploadCategoryImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.tempFileToUpload = file.item(0);
    this.categoryfd.append(WidgetImageContents.Category.toString(), this.fileToUpload);
    //var reader = new FileReader();
    //reader.onload = (event: any) => {
    //  this.selectedCategoryImage = event.target.result;
    //}
    //reader.readAsDataURL(this.fileToUpload);
  }

  AddCategoryImage() {
    if (this.tempFileToUpload != null) {
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.selectedCategoryImage = event.target.result;
      }
      reader.readAsDataURL(this.tempFileToUpload);
      this.tempFileToUpload = null;
    }
    //Category Hero img data structure => url,path
    this.categoryImageData= this.categoryImageRedirectUrl +
      "," +
      WidgetImageContents.DummyPath.toString();

    this.modalRef.hide();
  }

  // #region Add Brands to Array List

  AddCategoryBrands() {

    this.categoryBrandsList= [];
    for (var i = 0; i < this.selectedCategoryBrandIds.length; i++) {
      var selectedbrand = this.Brands.find(s => s.brandID == this.selectedCategoryBrandIds[i].brandID);
      
      this.categoryBrandsList.push(selectedbrand);
    }
   // this.selectedCategoryBrandIds = [];
    this.modalRef.hide();

  }

  AddCategorythumbnail() {
    if (this.selectedCategorythumbnailIds.length > 6) {
      this.isMax6Categories = false;
    } else {
      this.isMax6Categories = true;
      this.thumbnailCategoryList = [];
      for (var i = 0; i < this.selectedCategorythumbnailIds.length; i++) {
        var selectedCategory = this.subCategoryList.find(s => s.categoryID == this.selectedCategorythumbnailIds[i].categoryID);
        if (selectedCategory != null) {
          this.thumbnailCategoryList.push(selectedCategory);
        }
      }
      this.modalRef.hide();
    }
   

  }

  // #endregion

  // #region Popular Category

  AddPopularCategory() {
    if (this.selectedPopualarCategoryIds.length > 8) {
      this.isMax8Categories = false;
    } else {
      this.isMax8Categories = true;
      this.popularCategoryList = [];
      for (var i = 0; i < this.selectedPopualarCategoryIds.length; i++) {
        var selectedCategory = this.categoryList.find(s => s.categoryID == this.selectedPopualarCategoryIds[i].categoryID);
        if (selectedCategory != null) {
          this.popularCategoryList.push(selectedCategory);
        }
      }
      this.modalRef.hide();
    }


  }
  uploadBannerImage(file: FileList) {
    this.fileToUpload = file.item(0);
    this.tempFileToUpload = file.item(0);
    this.bannerfd.append(WidgetContentTypes.Banner.toString(), this.fileToUpload);
    //var reader = new FileReader();
    //reader.onload = (event: any) => {
    //  this.selectedCategoryImage = event.target.result;
    //}
    //reader.readAsDataURL(this.fileToUpload);
  }
  AddBannerImage() {
    if (this.tempFileToUpload != null) {
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.selectedBannerImage = event.target.result;
      }
      reader.readAsDataURL(this.tempFileToUpload);
      this.tempFileToUpload = null;
    }
    //Category Hero img data structure => url,path
    this.bannerImageData = this.bannerImageRedirectUrl +
      "," +
      WidgetImageContents.DummyPath.toString();

    this.modalRef.hide();
  }
  AddILoveAppBannerImage() {
    if (this.tempFileToUpload != null) {
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.selectedILoveAppBannerImage = event.target.result;
      }
      reader.readAsDataURL(this.tempFileToUpload);
      this.tempFileToUpload = null;
    }
    this.modalRef.hide();
  }

  ShowProductWidget() {
    // call database method to check saved Widget Contents
    this.widgetService.GetAllWidgetContentsOfProducts(this.currentWidgetTemplateID).subscribe(data => {
      this.productWidgetContentList = data;
      
      
      if (this.productWidgetType != "") {
        var enumProductWidgetType = this.productWidgetTypes.find(s => s.value == this.productWidgetType);
        var existingProductWidgetType = this.productWidgetContentList.find(s => s.pageWidgetID == this.savedPageWidgetId && s.type == enumProductWidgetType.title);
        if (existingProductWidgetType != null) {
          this.productWidgetTypeId = existingProductWidgetType.widgetContentID;
          this.pageWidget.sortOrder = parseInt(this.ColonSpliter(existingProductWidgetType.data)[1]);
        } else {
          this.productWidgetTypeId = 0;
        }
      } else {
        this.productWidgetTypeId = 0;
      }
      
    });
  }
  // #endregion

  GetCategoryListByParent(parentCategoryId: number) {
    this.SubcategoryList = this.categoryList.filter(s => s.parentCategoryID == parentCategoryId);
    this.ThirdLevelcategoryList = null;
    this.selectedPId = parentCategoryId;
  }

  GetSubCategoryListByParent(parentCategoryId: number) {
    this.ThirdLevelcategoryList = this.categoryList.filter(s => s.parentCategoryID == parentCategoryId);
    this.selectedCId = parentCategoryId;
  }
  onChange(event: any, id: number) {
    if (event.target.checked) {
      this.selectedMenuCategoryIds.push(id);
    } else {
      let index = this.selectedMenuCategoryIds.findIndex(s => s == id);
      this.selectedMenuCategoryIds.splice(index, 1);
    }
    let index = this.categoryList.findIndex(item => item.categoryID == id);
    this.categoryList[index].isChecked = !this.categoryList[index].isChecked;
  }

  onParentCategoryChange(id: number) {
    this.selectedParentCategoryId = id;
  }
  AddCategoryMenuItems() {
    this.menuParentCategoryList = [];
    this.menuCategoryList = [];
    this.menuSubcategoryList = [];
    //data structure for CategoryMenu items =>  parentId: comma seprated ChildIds
    this.categoryMenuData ="";
    let ids: string = "";
    for (var i = 0; i < this.selectedMenuCategoryIds.length; i++) {
      ids += "," + this.selectedMenuCategoryIds[i].toString();

      //populate the left Menu with items
      var category = this.categoryList.find(s => s.categoryID == this.selectedMenuCategoryIds[i]);
      if (category != null) {
        if (category.isParent == true && category.parentCategoryID > 0) {
          this.menuCategoryList.push(category);
        } else if (category.isParent == false) {
          this.menuSubcategoryList.push(category);
        }
      }
    }
    var pCategory = this.categoryList.find(s => s.categoryID == this.selectedParentCategoryId);
    if (pCategory != null) {
      this.menuParentCategoryList.push(pCategory);
    }
    this.categoryMenuData = this.selectedParentCategoryId.toString() + ids;
    this.modalRef.hide();
  }
  // #endregion category Widget

  SaveWidget() {
    if (this.currentWidgetTemplateID == 4) {
      //save image to server and get its path
      this.widgetService.SaveImage(this.fd).subscribe(
        data => {
          // data structure for multiple images => BrandColPosition:ImageName | BrandColPosition:ImageName
          let arrFullPath = this.PipeSignSpliter(data._body);
          for (var i = 0; i < arrFullPath.length; i++) {
            let imageName = this.ColonSpliter(arrFullPath[i]);
            if (imageName[0] == WidgetImageContents.BrandLeft.toString()) {
                // add new
                this.widgetContent = new WidgetContent();
                this.widgetContent.data = this.brandLeftData.replace(WidgetImageContents.DummyPath.toString(), imageName[1]);
                this.widgetContent.type = WidgetContentTypes.HeroImage.toString();
                this.widgetContentList.push(this.widgetContent);
            }
            if (imageName[0] == WidgetImageContents.BrandRight.toString()) {
               // add new
                this.widgetContent = new WidgetContent();
                this.widgetContent.data = this.brandRightData.replace(WidgetImageContents.DummyPath.toString(), imageName[1]);
                this.widgetContent.type = WidgetContentTypes.HeroImage.toString();
                this.widgetContentList.push(this.widgetContent);
            }
          }
          // adding brand tabs
          this.widgetContent = new WidgetContent();
          this.widgetContent.type = WidgetContentTypes.BrandTab.toString();
          this.widgetContent.data = "";
          //data structure for saving brand tab with BrandIds => BrandTabTitle:commaSepratedIds
          for (var i = 0; i < this.brandTabsList.length; i++) {
            var strBrandIds = "";
            for (var j = 0; j < this.brandTabsList[i].BrandsList.length; j++) {
              strBrandIds += "," + this.brandTabsList[i].BrandsList[j].brandID;
            }
            strBrandIds = strBrandIds.substring(1); // remove first comma ','
            this.widgetContent.data += "|" + this.brandTabsList[i].tabTitle + ":" + strBrandIds;
          }
          this.widgetContent.data = this.widgetContent.data.substring(1);// remove first pipe sign '|'
          this.widgetContentList.push(this.widgetContent);
          
          
          this.pageWidget.dynamicPageID = parseInt(this.customDPage);
          this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
          this.pageWidget.widgetContentList = this.widgetContentList;
          
          this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {
            
            this.pageWidget = new PageWidget();
            this.widgetContentList = [];
            this.router.navigate(["/page-widget-list"]);
          });

        });
    } else if (this.currentWidgetTemplateID == 1 || this.currentWidgetTemplateID == 2) {
      // To initialize the Content List by removing other's widget data
      this.widgetContentList = [];
      //save image to server and get its path
      this.widgetService.SaveImage(this.categoryfd).subscribe(
        data => {
          // data structure for image => EnumName:ImageName

          if (data._body != "") {
            let imageName = this.ColonSpliter(data._body);
            this.categoryImageData = this.categoryImageData.replace(WidgetImageContents.DummyPath.toString(), imageName[1]);
          } else if (this.selectedCategoryImage != "") {
            this.categoryImageData = this.categoryImageData.replace(WidgetImageContents.DummyPath.toString(), this.selectedCategoryImage.split('/')[2]);
          }
          // add new
          this.widgetContent = new WidgetContent();
          //this.widgetContent.widgetContentID = this.cateWidgetContentTypeHImageId;
          this.widgetContent.data = this.categoryImageData;
          this.widgetContent.type = WidgetContentTypes.HeroImage.toString();
          this.widgetContentList.push(this.widgetContent);

          // adding category brands
          this.widgetContent = new WidgetContent();
          //this.widgetContent.widgetContentID = this.cateWidgetContentTypeBrandId;
          this.widgetContent.type = WidgetContentTypes.CategoryBannerBrands.toString();
          this.widgetContent.data = "";
          //data structure for saving category BrandIds => commaSepratedIds
          var strBrandIds = "";
          for (var i = 0; i < this.categoryBrandsList.length; i++) {
            strBrandIds += "," + this.categoryBrandsList[i].brandID;
          }
          if (strBrandIds != "") {
            strBrandIds = strBrandIds.substring(1); // remove first comma ','
            this.widgetContent.data = strBrandIds;
          } else {
            this.widgetContent.data = this.categoryBrandIdsData;
          }
          this.widgetContentList.push(this.widgetContent);

          // adding thumbnail categories 
          this.widgetContent = new WidgetContent();
          //this.widgetContent.widgetContentID = this.cateWidgetContentTypeThmnailId;
          this.widgetContent.type = WidgetContentTypes.ThumbnailCategoryList.toString();
          this.widgetContent.data = "";
          //data structure for saving category Thumbnail => commaSepratedIds
          var strCategoryIds = "";
          for (var i = 0; i < this.selectedCategorythumbnailIds.length; i++) {
            strCategoryIds += "," + this.selectedCategorythumbnailIds[i].categoryID;
          }
          if (strCategoryIds != "") {
            strCategoryIds = strCategoryIds.substring(1); // remove first comma ','
            this.widgetContent.data = strCategoryIds;
          } else {
            this.widgetContent.data = this.categoryThumbnailIds;
          }
          this.widgetContentList.push(this.widgetContent);

          // adding Menu categories 
          this.widgetContent = new WidgetContent();
          //this.widgetContent.widgetContentID = this.cateWidgetContentTypeMenuId;
          this.widgetContent.type = WidgetContentTypes.CategoryMenu.toString();
          this.widgetContent.data = "";
          //data structure for saving category CategoryMenu => commaSepratedIds
          this.widgetContent.data = this.categoryMenuData;
          this.widgetContentList.push(this.widgetContent);
          // saving here
          
          this.pageWidget.dynamicPageID = parseInt(this.customDPage);
          this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
          this.pageWidget.widgetContentList = this.widgetContentList;
          
          //this.pageWidget.id = null; // in case of saving
          this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {
            
            this.pageWidget = new PageWidget();
            this.widgetContentList = [];
            this.router.navigate(["/page-widget-list"]);
          });

        });

    } else if (this.currentWidgetTemplateID == 3) {
      // popular category
      this.widgetContent = new WidgetContent();
      this.widgetContentList = [];
      //this.widgetContent.widgetContentID = this.widgetContentTypePopularCatId;
      this.widgetContent.type = WidgetContentTypes.ThumbnailCategoryList.toString();
      this.widgetContent.data = "";
      //data structure for saving category Thumbnail => commaSepratedIds
      var strCategoryIds = "";
      for (var i = 0; i < this.selectedPopualarCategoryIds.length; i++) {
        strCategoryIds += "," + this.selectedPopualarCategoryIds[i].categoryID;
      }
      if (strCategoryIds != "") {
        strCategoryIds = strCategoryIds.substring(1); // remove first comma ','
        this.widgetContent.data = strCategoryIds;
      } else {
        this.widgetContent.data = this.popularCategoryThumbnailIds;
      }
      this.widgetContentList.push(this.widgetContent);
      // saving here
      
      this.pageWidget.dynamicPageID = parseInt(this.customDPage);
      this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
      this.pageWidget.widgetContentList = this.widgetContentList;
      
      this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {
        
        this.pageWidget = new PageWidget();
        this.widgetContentList = [];
        this.router.navigate(["/page-widget-list"]);
      });
    } else if (this.currentWidgetTemplateID == 5) {
      
      var enumProductWidgetType = this.productWidgetTypes.find(s => s.value == this.productWidgetType);

      this.widgetContent = new WidgetContent();
      this.widgetContentList = [];
      this.widgetContent.type = enumProductWidgetType.title;
      if (isNaN(this.pageWidget.sortOrder)) {
        this.pageWidget.sortOrder = 0;
      }
      if (enumProductWidgetType.title == WidgetContentTypes.FlashSaleProducts.toString()) {
        this.widgetContent.data = this.saleId + "|SortOrder:" + this.pageWidget.sortOrder;
      } else {
        this.widgetContent.data = "SortOrder:" + this.pageWidget.sortOrder;
      }
      //this.widgetContent.widgetContentID = this.productWidgetTypeId;
      this.widgetContentList.push(this.widgetContent);
      this.pageWidget.dynamicPageID = parseInt(this.customDPage);
      this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
      this.pageWidget.widgetContentList = this.widgetContentList;
      this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {
        
        this.pageWidget = new PageWidget();
        this.widgetContentList = [];
        this.router.navigate(["/page-widget-list"]);
      });

    } else if (this.currentWidgetTemplateID == 6) {
      // Best Vendors
      this.widgetContent = new WidgetContent();
      this.widgetContentList = [];
      this.widgetContent.type = WidgetContentTypes.BestVendors.toString();
      this.widgetContent.data = "Will be Dynamic Query if needed";
      //this.widgetContent.widgetContentID = this.widgetContentTypeVendorId;
      this.widgetContentList.push(this.widgetContent);
      this.pageWidget.dynamicPageID = parseInt(this.customDPage);
      this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
      this.pageWidget.widgetContentList = this.widgetContentList;
      this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {
        
        this.pageWidget = new PageWidget();
        this.widgetContentList = [];
        this.router.navigate(["/page-widget-list"]);
      });
    } else if (this.currentWidgetTemplateID == 7) {
      //save image to server and get its path
      this.widgetService.SaveImage(this.bannerfd).subscribe(
        data => {
          // data structure for image => EnumName:ImageName
          if (data._body != "") {
            let imageName = this.ColonSpliter(data._body);
            this.bannerImageData = this.bannerImageData.replace(WidgetImageContents.DummyPath.toString(), imageName[1]);
          } else if (this.selectedBannerImage != "") {
            this.bannerImageData = this.bannerImageData.replace(WidgetImageContents.DummyPath.toString(), this.selectedBannerImage.split('/')[2]);
          }
          // add new
          this.widgetContent = new WidgetContent();
          this.widgetContentList = [];
          //this.widgetContent.widgetContentID = this.bannerWidgetContentId;
          this.widgetContent.data = this.bannerImageData;
          this.widgetContent.type = WidgetContentTypes.Banner.toString();
          this.widgetContentList.push(this.widgetContent);

          // saving here
          
          this.pageWidget.dynamicPageID = parseInt(this.customDPage);
          this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
          this.pageWidget.widgetContentList = this.widgetContentList;
          
          //this.pageWidget.id = null; // in case of saving
          this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {
            
            this.pageWidget = new PageWidget();
            this.widgetContentList = [];
            this.router.navigate(["/page-widget-list"]);
          });

        });
    } else if (this.currentWidgetTemplateID == 8) {
      //save image to server and get its path
      this.widgetService.SaveImage(this.bannerfd).subscribe(
        data => {
          // data structure for image => EnumName:ImageName
          if (data._body != "") {
            let imageName = this.ColonSpliter(data._body);
            // add new
            this.widgetContent = new WidgetContent();
            this.widgetContentList = [];
            //this.widgetContent.widgetContentID = this.bannerWidgetContentId;
            this.widgetContent.data = imageName[1];
            this.widgetContent.type = WidgetContentTypes.ILoveAppBanner.toString();
            this.widgetContentList.push(this.widgetContent);

            // saving here
            
            this.pageWidget.dynamicPageID = parseInt(this.customDPage);
            this.pageWidget.widgetTemplateID = this.currentWidgetTemplateID;
            this.pageWidget.widgetContentList = this.widgetContentList;
            
            //this.pageWidget.id = null; // in case of saving
            this.widgetService.SaveWidget(this.pageWidget).subscribe(result => {
              
              this.pageWidget = new PageWidget();
              this.widgetContentList = [];
              this.router.navigate(["/page-widget-list"]);
            });
          }
        });
    }
    this.toastr.success('Widget Saved successfully.', 'Success');
  }
  // Code for Brand Edit

  WidgetContentInitialization() {
    this.categoryBrandsList = [];
    this.thumbnailCategoryList = [];
    this.menuParentCategoryList = [];
    this.menuCategoryList = [];
    this.menuSubcategoryList = [];
    this.brandTabsList = [];
    this.selectedCategoryBrandIds = [];
    this.selectedCategorythumbnailIds = [];
    this.fd = new FormData();
    this.categoryfd = new FormData();
    this.selectedCategoryImage = "";
    this.categoryImageRedirectUrl = "";
    this.imageRedirectUrlLeft = "";
    this.selectedBrandImageLeft = "";
    this.imageRedirectUrlRight = "";
    this.selectedBrandImageRight = "";
    this.categoryBrandIdsData = "";
    this.categoryThumbnailIds = "";
    this.categoryMenuData = "";
    this.categoryImageData = "";
    // for category 2
    this.categoryBrandsList2 = [];
    this.thumbnailCategoryList2 = [];
    this.menuParentCategoryList2 = [];
    this.menuCategoryList2 = [];
    this.menuSubcategoryList2 = [];
    this.selectedCategoryImage2 = "";
    this.categoryImageRedirectUrl2 = "";
    this.pageWidget = new PageWidget();
    this.widgetContentList = [];
    this.selectedPopualarCategoryIds = [];
    this.popularCategoryList = [];
    this.widgetContentTypePopularCatId = 0;
    this.widgetContentTypeVendorId = 0;
    this.productWidgetType = "";
    this.productWidgetTypeId = 0;
    this.savedPageWidgetId = 0;
    this.savedProductWidgetTypes = [];
    this.bannerfd = new FormData();
    this.selectedBannerImage = "";
    this.bannerImageRedirectUrl = "";
    this.saleId = 0;

  }
  LaodSavedWidgets(isPageDropdownCalled: boolean) {

    // check to load all widgets of page
    if (isPageDropdownCalled) {
      this.currentWidgetTemplateID = 0;
      this.showAllWidget = true;
    } else {
      this.showAllWidget = false;
    }
    this.WidgetContentInitialization();

    this.widgetService.GetPageWidgetsByPageID(parseInt(this.customDPage), this.currentWidgetTemplateID).subscribe(
      data => {
       
        this.pageWidgetList = data;
        for (var p = 0; p < this.pageWidgetList.length; p++) {
          this.pageWidget.widgetTemplateID = this.pageWidgetList[p].widgetTemplateID;
          this.currentWidgetTemplateID = this.pageWidgetList[p].widgetTemplateID;
          this.pageWidget.sortOrder = this.pageWidgetList[p].sortOrder;
          this.pageWidget.pageWidgetID = this.pageWidgetList[p].pageWidgetID;
          // retaining PageWID To check product widget
          this.savedPageWidgetId=this.pageWidgetList[p].pageWidgetID;
          //end for product widget
          this.pageWidget.id = this.pageWidgetList[p].id;
          this.widgetContentList = this.pageWidgetList[p].widgetContentList;
          var widgetTemplate = this.widgetTemplateList.find(s => s.widgetTemplateID == this.pageWidgetList[p].widgetTemplateID)
          if (widgetTemplate != null) {
            if (widgetTemplate.widgetType == WidgetTypes.Brands.toString()) {
              this.brandTabsList = [];
              for (var i = 0; i < this.widgetContentList.length; i++) {
                //check if template is Brand Widget
                if (this.widgetContentList[i].type == WidgetContentTypes.HeroImage.toString()) {
                  // Data Structure BrandLeft: Url, Image" 
                  let arrData = this.PipeSignSpliter(this.widgetContentList[i].data);
                  let arrUrlAndImage = this.CommaSpliter(arrData[1]);
                  if (arrData[0].toString() == WidgetImageContents.BrandLeft.toString()) {
                    this.imageRedirectUrlLeft = arrUrlAndImage[0];
                    this.selectedBrandImageLeft = "Images/WidgetContentImages/" + arrUrlAndImage[1];

                  } else if (arrData[0].toString() == WidgetImageContents.BrandRight.toString()) {
                    this.imageRedirectUrlRight = arrUrlAndImage[0];
                    this.selectedBrandImageRight = "Images/WidgetContentImages/" + arrUrlAndImage[1];
                  }

                } else if (this.widgetContentList[i].type == WidgetContentTypes.BrandTab.toString()) {
                  let arrBrandTabs = this.PipeSignSpliter(this.widgetContentList[i].data);
                  for (var j = 0; j < arrBrandTabs.length; j++) {
                    let arrTabAndIds = this.ColonSpliter(arrBrandTabs[j]);
                    
                    this.brandTab = new BrandTabsList();
                    this.brandTab.tabTitle = arrTabAndIds[0];
                    let existingBrandIds = this.CommaSpliter(arrTabAndIds[1]);
                    for (var k = 0; k < existingBrandIds.length; k++) {
                      var selectedbrand = this.Brands.find(s => s.brandID == parseInt(existingBrandIds[k]));
                      
                      this.brandTab.BrandsList.push(selectedbrand);
                    }
                    this.brandTabsList.push(this.brandTab);
                  }

                }
              }

            } else if (widgetTemplate.widgetType == WidgetTypes.Category1.toString() || widgetTemplate.widgetType == WidgetTypes.Category2.toString()) {
              // Load at page change
              // check to show all pages
              for (var cate1Index = 0; cate1Index < this.widgetContentList.length; cate1Index++) {
                if (this.widgetContentList[cate1Index].type == WidgetContentTypes.HeroImage.toString()) {
                  this.cateWidgetContentTypeHImageId = this.widgetContentList[cate1Index].widgetContentID;
                  this.categoryImageData = this.widgetContentList[cate1Index].data;
                  let arrUrlAndImage = this.CommaSpliter(this.categoryImageData);
                  if (this.showAllWidget && widgetTemplate.widgetType == WidgetTypes.Category2.toString()) {
                    this.categoryImageRedirectUrl2 = arrUrlAndImage[0];
                    this.selectedCategoryImage2 = "Images/WidgetContentImages/" + arrUrlAndImage[1];
                  } else {
                    this.categoryImageRedirectUrl = arrUrlAndImage[0];
                    this.selectedCategoryImage = "Images/WidgetContentImages/" + arrUrlAndImage[1];
                  }

                } else if (this.widgetContentList[cate1Index].type == WidgetContentTypes.CategoryBannerBrands.toString()) {
                  this.cateWidgetContentTypeBrandId = this.widgetContentList[cate1Index].widgetContentID;
                  this.categoryBrandIdsData = this.widgetContentList[cate1Index].data;
                  let arrBrandIds = this.CommaSpliter(this.categoryBrandIdsData);
                  for (var i = 0; i < arrBrandIds.length; i++) {
                    var selectedbrand = this.Brands.find(s => s.brandID == parseInt(arrBrandIds[i]));
                    if (this.showAllWidget && widgetTemplate.widgetType == WidgetTypes.Category2.toString()) {
                      this.categoryBrandsList2.push(selectedbrand);
                    } else {
                      this.categoryBrandsList.push(selectedbrand);
                    }

                  }

                } else if (this.widgetContentList[cate1Index].type == WidgetContentTypes.ThumbnailCategoryList.toString()) {
                  this.cateWidgetContentTypeThmnailId = this.widgetContentList[cate1Index].widgetContentID;
                  this.categoryThumbnailIds = this.widgetContentList[cate1Index].data;
                  let arrThumbnailCatIds = this.CommaSpliter(this.categoryThumbnailIds);
                  for (var i = 0; i < arrThumbnailCatIds.length; i++) {
                    var selectedCategory = this.subCategoryList.find(s => s.categoryID == parseInt(arrThumbnailCatIds[i]));
                    if (selectedCategory != null) {
                      if (this.showAllWidget && widgetTemplate.widgetType == WidgetTypes.Category2.toString()) {
                        this.thumbnailCategoryList2.push(selectedCategory);
                      } else {
                        this.thumbnailCategoryList.push(selectedCategory);
                      }
                    }
                  }

                } else if (this.widgetContentList[cate1Index].type == WidgetContentTypes.CategoryMenu.toString()) {
                  this.cateWidgetContentTypeMenuId = this.widgetContentList[cate1Index].widgetContentID;
                  this.categoryMenuData = this.widgetContentList[cate1Index].data;
                  let arrCateMenuIds = this.CommaSpliter(this.categoryMenuData);
                  for (var i = 0; i < arrCateMenuIds.length; i++) {
                    //populate the left Menu with items
                    var category = this.categoryList.find(s => s.categoryID == parseInt(arrCateMenuIds[i]));
                    if (category != null) {
                      if (this.showAllWidget && widgetTemplate.widgetType == WidgetTypes.Category2.toString()) {
                        if (category.parentCategoryID == 0) {
                          this.menuParentCategoryList2.push(category);
                        } else if (category.isParent == true && category.parentCategoryID > 0) {
                          this.menuCategoryList2.push(category);
                        } else if (category.isParent == false) {
                          this.menuSubcategoryList2.push(category);
                        }

                      } else {
                        if (category.parentCategoryID == 0) {
                          this.menuParentCategoryList.push(category);
                        } else if (category.isParent == true && category.parentCategoryID > 0) {
                          this.menuCategoryList.push(category);
                        } else if (category.isParent == false) {
                          this.menuSubcategoryList.push(category);
                        }
                      }
                    }
                  }
                }

              }
            } else if (widgetTemplate.widgetType == WidgetTypes.PopularCategory.toString()) {
              for (var popularCatIndex = 0; popularCatIndex < this.widgetContentList.length; popularCatIndex++) {
                this.widgetContentTypePopularCatId = this.widgetContentList[popularCatIndex].widgetContentID;
                this.popularCategoryThumbnailIds = this.widgetContentList[popularCatIndex].data;
                let arrThumbnailCatIds = this.CommaSpliter(this.popularCategoryThumbnailIds);
                for (var i = 0; i < arrThumbnailCatIds.length; i++) {
                  var selectedPopularCategory = this.categoryList.find(s => s.categoryID == parseInt(arrThumbnailCatIds[i]));
                  if (selectedPopularCategory != null) {
                    this.popularCategoryList.push(selectedPopularCategory);
                  }
                }
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.BestVendor.toString()) {
              for (var vendorIndex = 0; vendorIndex < this.widgetContentList.length; vendorIndex++) {
                this.widgetContentTypeVendorId = this.widgetContentList[vendorIndex].widgetContentID;
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.Products.toString())
            {
              for (var ProductIndex = 0; ProductIndex < this.widgetContentList.length; ProductIndex++) {
                var enumProductWidgetType = this.productWidgetTypes.find(s => s.title == this.widgetContentList[ProductIndex].type);
                this.savedProductWidgetTypes.push(enumProductWidgetType.value);
                if (this.widgetContentList[ProductIndex].type == WidgetContentTypes.FlashSaleProducts.toString()) {
                  this.saleId = parseInt(this.PipeSignSpliter(this.widgetContentList[ProductIndex].data)[0]);
                }
              }
            } else if (widgetTemplate.widgetType == WidgetTypes.Banner.toString()) {
              for (var bannerIndex = 0; bannerIndex < this.widgetContentList.length; bannerIndex++) {
                this.bannerWidgetContentId = this.widgetContentList[bannerIndex].widgetContentID;
                this.bannerImageData = this.widgetContentList[bannerIndex].data;
                let arrUrlAndImage = this.CommaSpliter(this.bannerImageData);
                  this.bannerImageRedirectUrl = arrUrlAndImage[0];
                  this.selectedBannerImage = "Images/WidgetContentImages/" + arrUrlAndImage[1];
              }
            }
        }
      }
      });
  }
  //End Brand Edit

  //common functions
  PipeSignSpliter(str: string): string[] {
    return str != "" ? str.toString().split('|') : [];
  }

  ColonSpliter(str: string): string[] {
    return str != "" ? str.toString().split(':') : [];
  }
  CommaSpliter(str: string): string[] {
    return str != "" ? str.toString().split(',') : [];
  }
}
enum WidgetImageContents {
  BrandLeft = "BrandLeft",
  BrandRight = "BrandRight",
  DummyPath = "DummyPath",
  Category = "Category",
}
enum WidgetContentTypes {

  CategoryMenu = "Category Menu",
  HeroImage = "Hero Image",
  ThumbnailCategoryList = "Thumbnail Category List",
  CategoryBannerBrands = "Category Banner Brands",
  BrandTab = "Brand Tab",
  Banner = "Banner",
  ILoveAppBanner = "I Love App Banner",
  BestVendors = "Best Vendors",
  TopSellingProducts = "Top Selling Products",
  RecentProducts = "Recent Products",
  FeaturedProducts = "Featured Products",
  OnsaleProducts = "Onsale Products",
  TopRatedProducts = "Top Rated Products",
  FlashSaleProducts = "Flash Sale Products",
  JustForYou = "Just For You",
}
enum WidgetTypes {

  Category1 = "Category1",
  Category2 = "Category2",
  PopularCategory = "PopularCategory",
  Products = "Products",
  Brands = "Brands",
  BestVendor = "BestVendor",
  Banner = "Banner",
}
enum ProductWidgetTypes {
  TopSellingProducts = "Top Selling Products",
  RecentProducts = "Recent Products",
  FeaturedProducts = "Featured Products",
  OnsaleProducts = "Onsale Products",
  TopRatedProducts = "Top Rated Products",
  FlashSaleProducts = "Flash Sale Products",
  JustForYou = "Just For You",
}
export class BrandTabsList {
  public tabTitle: string;
  public BrandsList: Brand[] = [];
}



// WEBPACK FOOTER //
// ./src/app/widget/create-page-widget/create-page-widget.component.ts